// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"we_a bhn_b","TwoDimsListFeature__item":"we_b bhn_we","TwoDimsListFeature__item__text":"we_c bhn_vt"};